'use strict';

var React = require('react');

var SvgAnalyticsDonutMinor = function SvgAnalyticsDonutMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.896 1.145c-1.116-.305-1.959.52-2.18 1.32l-.155.557a7 7 0 1 0 6.416 6.417l.557-.155c.8-.221 1.626-1.064 1.321-2.18-.346-1.265-1.274-2.585-2.324-3.635-1.05-1.05-2.37-1.978-3.635-2.324Zm-2.883 3.855h-.013a5 5 0 1 0 5 5v-.013l-2.051.569a3 3 0 1 1-3.505-3.505l.569-2.051Zm-.013 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }));
};

exports.SvgAnalyticsDonutMinor = SvgAnalyticsDonutMinor;
